export default {
  methods: {
    isPlaceholder(value) {
      return this.isEmpty(value)
    },

    isEmpty(value) {
      return !value || !/\S/.test(value)
    },

    isExplicitlyFalse(value) {
      return typeof value !== 'undefined' && value === false
    },

    isLoading(field) {
      return this.executeIfFunction(field.loading)
    },

    executeIfFunction(variable) {
      return typeof variable === 'function' ? variable() : variable
    },

    isValidDate(dateString) {
      if (!/^\d{4}-\d{2}-\d{2}$/.test(dateString)) {
        return false
      }
      const dateSplit = dateString.split('-').map(d => parseFloat(d))
      const month = dateSplit[1] - 1
      const date = new Date(dateSplit[0], month, dateSplit[2])

      return (
        date.getFullYear() == dateSplit[0] &&
        date.getMonth() == month &&
        date.getDate() == dateSplit[2]
      )
    },
  },
}
